module.exports = __webpack_public_path__ + "static/media/arrow.8cf8a0ae.svg";